/**
 * Internal dependencies.
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';
import { ContainerIcon as icon } from '../../components/Icons';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes, supports } = metadata;

const settings = {
	title: __( 'Slide Item' ),
	description: __( 'Gutenify slider item.' ),
	icon: <Icon icon={ icon } />,
	parent: [ 'gutenify/slider' ],
	keywords: [
		'gutenify',
		__( 'Slide' ),
		__( 'Slider' ),
		__( 'Slider item' ),
		__( 'Slide item' ),
	],
	example: {
		attributes: {
		},
	},
	attributes,
	edit,
	save,
	supports,
};

export { name, category, settings };
